<div class="content">
  <mat-tab-group [selectedIndex]="isInforTab" #myTabGroup (selectedIndexChange)="changeTabSelected($event)">
    <mat-tab [label]="'labor_utilization_report.labor_contract_configuration' | translate">
      <app-config-hdld *ngIf="isInforTab == 0"></app-config-hdld>
    </mat-tab>

    <mat-tab [label]="'labor_utilization_report.report_criteria_link_contract_template' | translate">
      <app-list-labor-utilization-report *ngIf="isInforTab == 1"></app-list-labor-utilization-report>
    </mat-tab>
  </mat-tab-group>
</div>